export default __webpack_public_path__ + "static/media/3118.6de6a468.jpg";